import styled from 'styled-components';

import { styledLayout, styledReset } from '@pkg/primitives';

export const HiddenClipPath = styled.div`
    ${styledReset.borderBox};
    ${styledLayout.visuallyHidden};
`;
